import { useQuery } from "@tanstack/react-query";
import { INSIGHT_SUMMARY_QUERY_KEY } from "../query/insight-summary-query-keys";
import { getInsightsSummary } from "../services/insight-summary.service";

export const useInsightsSummaryQuery = () =>
	useQuery({
		queryKey: INSIGHT_SUMMARY_QUERY_KEY,
		queryFn: getInsightsSummary,
		initialData: {
			alerts: 0,
			opportunities: 0,
			reminders: 0,
			total: 0,
		},
	});
